module.exports = __webpack_public_path__ + "47652be0dbfca67e4022e828fc1f3444.svg";